import React, { useState, useEffect, useRef } from 'react';
import {Button } from "reactstrap";

// import Navbar from '../Navbar/Navbar';
import Navbar from '../Navbar/Navbar_00';
import Footer from "../Footer/Footer";

import Loader from '../../../loader';

import './Forms.css';
import parse from 'html-react-parser';

import * as Hosts from '../../../Hosts';
import {
    // set_language,
    // reqGET,
	//reqPOST,
    //repo_banner_link,
    content_language,
    functionSendMail

} from '../../../Utils';


import { language } from '../WEBContent/Language';

import Swal from 'sweetalert2';

const ContactForm = (props) => {

    const [ , set_dados ] = useState( null )
	const dados_config = useRef({})

    const navbar_interface = {
        id: '',
        info: {},
        content: {
            childs: []
        }
    }
    const navbar = useRef(navbar_interface)

    const data_interface = {
        id: '',
        info: {
            companycode: Hosts.companycode,
            name: '',
            email: '',
            subject: '',
            message: '',
            rgpd: false,    
        }

    }
    const dados = useRef( data_interface )

    const [lang, set_lang] = useState('pt')
    const [, set_lang_id] = useState('1')

    const [isloading, setLoading] = useState(true)
   
    useEffect(() => { 

        if(props.info !== undefined && props.info !== null && props.info !== '') {
            set_dados(dados_config.current = props.info.state.dados_config)
            set_dados(navbar.current = props.info.state.dados_navbar)
        }

        try {

            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                set_lang_id(el.id)
                }
            })

            setLoading(false)

            return

        } catch {
            console.log('nada')

			return
		}
    
    }, [props]); 

    const [agree, setAgree] = useState(false);

    const checkboxHandler = () => {
      // if agree === true, it will be set to false
      // if agree === false, it will be set to true
      setAgree(!agree);
      // Don't miss the exclamation mark
    }

    const checkboxHandler_reload = (agree) => {
        //console.log('AGREE', agree)
        if (agree === true)
            return true
        else 
            return false
        // if agree === false, it will be set to true
        //setAgree(!agree);
        // Don't miss the exclamation mark
    }

    const [counterText, setCounterText] = useState('');

    const handle_change_info = (e) => {
		const { name, value } = e.target;

		set_dados(dados.current.info[name] = value)
        //console.log('Dados Current:' + JSON.stringify(dados))
    }

    const handle_change_info_textarea = (e) => {
        const { name, value } = e.target;
        //console.log('NAME ', name)
        //console.log('VALUE ', value)
        setCounterText(e.target.value)

        set_dados(dados.current.info[name] = value)
        //set_dados(dados.current.info.date.creation = new Date())
        //console.log('Dados Current:' + JSON.stringify(dados))
    }

    const handleSubmit = async e => {
        e.preventDefault();

        let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +';border:1px solid transparent;border-collapse:collapse;">' +
            '<tr style="border-collapse: collapse;">' +
                '<td align="left" class style="padding:40px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                    '<div>'+
                        '<h4>'+ language[lang].contact_form +':</h4>'+
                        '<span><b>'+ language[lang].name +': </b><label>' + dados.current.info.name + '</label></span>' +
                        '<br/>'+
                        '<span"><b>Email: </b><label>' + dados.current.info.email + '</label></span>'+
                        '<br/>'+
                        '<span><b>'+ language[lang].subject +': </b><label>' + dados.current.info.subject + '</label></span>' +
                        '<br/>'+
                        '<br/>' +
                        '<span><b>'+ language[lang].message +': </b><label>' + dados.current.info.message + '</label></span>' +
                        '<br/>'+
                    '</div>'+
                '</td>' +
            '</tr>' +
        '</table>'

        functionSendMail(dados_config.current.content[0].contacts.email_form, [dados.current.info.email], [dados_config.current.content[0].contacts.email_form], dados_config.current.info.name + ' - ' + language[lang].contact_form, mail_content, [], dados_config)
            .then((res) => {
                if(res === true) {
                    set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
                    document.getElementById('agree').checked = false
                    setAgree(false)
                    //setRefresh(refresh + 1)
                    Swal.fire({
                        title: language[lang].contact_form,
                        text: language[lang].sent_successfully,
                        icon: 'success',
                        //showCancelButton: true,
                        confirmButtonColor: '#08396a',
                        //confirmButtonText: 'Tentar novamente',
                        })
                }
                else {
                    console.log('erro')
                }
            })

    }
        
    return (isloading ?
		<Loader />
    :
        <div>
            <Navbar dados_config={dados_config.current} dados_navbar={navbar.current} />
            {/*<Breadcrumb dados_config={dados_config} dados_navbar={navbar} dados_content={content} />*/}
            <section className="margemBody">

                <div className="container-fluid">
                    <div className="row">
                        <div className='col-12 bg-light py-5'>
                            <div className='container'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <h3 className="titulo-primario">
                                            <span>
                                                {language[lang].contacts}
                                            </span>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="container my-4">
                    <form onSubmit={handleSubmit}>

                        <div className="row">
                            <div className="col-12 col-md-6">

                                <div className='row'>
                                    <div className="col-12 my-3">
                                        <p className="subtitulo-secundario">
                                        
                                        </p>
                                    </div>
                                    <div className='col-12'>
                                        <p>
                                            {
                                            dados_config.current.content[0].contacts.tlm !== '' ?
                                                <span>
                                                    <strong>{language[lang].tlf}:</strong> {dados_config.current.content[0].contacts.tlf} 
                                                    <br />
                                                </span>
                                            :
                                                null
                                            }
                                            {
                                            dados_config.current.content[0].contacts.tlm !== '' ?
                                                <span>
                                                    <strong>{language[lang].tlm}:</strong> {dados_config.current.content[0].contacts.tlm} 
                                                    <br />
                                                </span>
                                            :
                                                null
                                            }
                                            {
                                            dados_config.current.content[0].contacts.email !== '' ?
                                                <span>
                                                    <strong>{language[lang].email}:</strong> {dados_config.current.content[0].contacts.email}
                                                </span>
                                            :
                                                null
                                            }
                                        </p>
                                        {
                                        dados_config.current.content[0].contacts.address !== '' ?
                                            <span>
                                                <strong>{language[lang].morada}</strong> <br />
                                                {parse(dados_config.current.content[0].contacts.address.replace(/(?:\r\n|\r|\n)/g, '<br />'))}
                                            </span>
                                        :
                                            null
                                        }
                                    </div>
                                </div>

                            </div>
                            <div className="col-12 col-md-6 mt-5 mt-md-0">
                                <div className="row">
                                    <div className="col-12">
                                        <p>
                                            {language[lang].read_terms_conditions}
                                            {/*Leia os nossos <a href={Hosts.WEB_SITE_URI + "terms_conditions"} target="_blank" rel="noreferrer">termos e condições</a> antes de submeter o formulário. Ao submeter concorda com os termos do nosso serviço.*/}
                                        </p>
                                    </div>

                                    <div className="col-12 col-sm-6">
                                        <label>{language[lang].name}*</label>
                                        <input type="text" name="name" value={dados.current.info.name} className="form-control" placeholder="" onChange={handle_change_info} required />
                                    </div>
                                    <div className="col-12 col-sm-6">
                                        <label>{language[lang].email}*</label>
                                        <input type="email" name="email" 
                                            value={dados.current.info.email} 
                                            className="form-control" 
                                            placeholder="" 
                                            onChange={handle_change_info} required
                                        /> 
                                    </div>

                                    <div className="col-12 mt-2">
                                        <label>{language[lang].subject}*</label>
                                        <input type="subject" name="subject" 
                                            value={dados.current.info.subject} 
                                            className="form-control" 
                                            placeholder="" 
                                            onChange={handle_change_info} required
                                        /> 
                                    </div>
                                    <div className="col-12 mt-2">
                                        <label>{language[lang].message}*</label>
                                        <textarea
                                            style={{ height: "180px", width: "100%" }}
                                            id="message"
                                            name="message"
                                            maxLength="600"
                                            value={dados.current.info.message}
                                            onChange={handle_change_info_textarea}
                                            required
                                        />
                                        <p className="text-right my-2 font-weight-bold">{language[lang].maximum_numbers_of_caracters}&#58;&nbsp;{counterText.length}/600</p>
                                        {/* <TextareaCounter countLimit={200} style={{height: "100px", width: "100%"}} id="message" name="message" value={dados.current.info.message} onChange={handle_change_info} required/>
                                        <input type="text" name="message" value={dados.current.info.message} className="form-control" placeholder="" onChange={handle_change_info} /> */}
                                    </div>

                                    <div className="col-12">
                                        <input type="checkbox" id="agree" onChange={checkboxHandler} defaultChecked={checkboxHandler_reload(agree)}/>
                                        <label className="pl-2" htmlFor="agree">{language[lang].agree_terms_conditions}</label> <a href={Hosts.WEB_SITE_URI + "terms-conditions"} target="_blank" rel="noreferrer">{language[lang].terms_conditions_link}</a>
                                        <label className="pl-2 small" htmlFor="agree">{language[lang].terms_conditions_required}</label>
                                    </div>

                                    <div className='col-12 text-right'>
                                        {/*{console.log('AGREE2', agree)}
                                        {console.log('MAIL: ', JSON.stringify(mailOptions))}*/}
                                        <Button disabled={!agree} className="mt-5 mx-auto" color="primary">{language[lang].send}</Button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </form>
                </div>

                <div className="mapouter">
                    <div className="gmap_canvas">
                        <iframe width="100%" height="500" id="gmap_canvas" title="gmap_canvas" src={"https://maps.google.com/maps?q=" + dados_config.current.content[0].contacts.gps.lat + "," + dados_config.current.content[0].contacts.gps.lng + "&hl=es&z=18&maptype=satellite&output=embed"} style={{border: '0'}} allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                    </div>
                </div>

            </section>
            <Footer dados_config={dados_config.current} dados_navbar={navbar.current} />
        </div>
    )

};

export default ContactForm;